let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7YsXG")).then(() => parcelRequire('1io2P'));